import { Box } from '@chakra-ui/react'
import { Fragment } from 'react'

import envConfig from '@/config/env'

import {
  ReferralExample,
  ReferralHero,
  ReferralNav,
  Registration,
  WhatIsReferral,
  WhyReferral,
} from '../referral'
import { Contact } from '@/components/Landing'

import { REFERRAL_META } from '../constants/referral'

import { DefineSeo } from '@/lib/seo'

function ReferralPage(): React.ReactElement {
  return (
    <Fragment>
      <DefineSeo
        title={REFERRAL_META.title}
        description={REFERRAL_META.description}
        openGraph={{
          type: 'website',
          locale: 'en_EN',
          url: envConfig.APP_URL,
          site_name: 'PDPAPro',
          title: REFERRAL_META.title,
          description: REFERRAL_META.description,
          images: [
            {
              url: `${envConfig.APP_URL}/images/og/referral-og.png`,
              width: 1200,
              height: 630,
            },
          ],
        }}
      />
      <Box
        sx={{
          '.container': {
            maxW: '1124px',
            mx: 'auto',
            px: 0,
          },
          section: {
            pos: 'relative',
          },
          overflow: 'hidden',
        }}
      >
        <ReferralNav />
        <ReferralHero id="referral-hero" />
        <WhatIsReferral id="what-is-referral" />
        <WhyReferral id="why-pdpa-pro-referral" />
        <ReferralExample id="referral-example" />
        <Registration id="referral-registration" />
        <Contact />
      </Box>
    </Fragment>
  )
}

export default ReferralPage
